import { createFileRoute } from '@tanstack/react-router'
import CommissionStatistics from '@/features/commission-statistics'

export const Route = createFileRoute('/_authenticated/commission-statistics/')({
  component: CommissionStatistics,
})
